import styled from 'styled-components'

export const StyledEnvelopeContainer = styled.div`
  position: relative;
  padding-bottom: 10px;
`
